import { useDispatch, useStore } from 'react-redux';
import { dockConnectionManager, onboardConnectionManager } from 'src/helper/HubConnectionManager';
import { getDeviceConnectionGroups, getDeviceInfo, getDeviceTelemetries } from '../common/deviceUtils';
import { useEffect, useRef } from 'react';
import useCurrentUserId from 'src/helper/useCurrentUserId';
import { setDeviceFlightAuthorityStatus } from '../DeviceServiceSlice';
import { DjiFlightJoystickAuthorityMode, DjiFlightJoystickAuthoritySwitchEvent } from '../common/deviceConstants';

function useDeviceFlightAuthorityObserver() {
  const messageHandlerIds = useRef([]);
  const permanentIntervalId = useRef(null);
  const store = useStore();
  const dispatch = useDispatch();
  const userId = useCurrentUserId();
  const dockDrcRequestTimestamps = useRef({});

  useEffect(() => {
    messageHandlerIds.current = onboardConnectionManager.subscribeGroupMessages([
      {
        identity: 'onboardDeviceTelemetries/*',
        name: ['highFreqChannel'],
        handler: (message, meta) => {
          if(message?.flightControl) {
            const onboardDeviceId = meta?.fromUserId?.split('_')?.[0];
            const deviceInfo = getDeviceInfo(onboardDeviceId);
            const parentDeviceId = deviceInfo?.attachedToDock;

            dispatch(setDeviceFlightAuthorityStatus({
              deviceId: onboardDeviceId,
              data: {
                authorityMode: message?.flightControl?.controlAuthority,
                authorityModeReason: message?.flightControl?.controlAuthorityReason,
              }
            }));

            if(parentDeviceId) {
              dispatch(setDeviceFlightAuthorityStatus({
                deviceId: parentDeviceId,
                data: {
                  authorityMode: message?.flightControl?.controlAuthority,
                  authorityModeReason: message?.flightControl?.controlAuthorityReason,
                }
              }));
            }
          }
        },
      },
    ], 'dock-device-observer');

    dockConnectionManager.subscribeGroupMessages([
      {
        identity: 'dockDeviceState/*',
        name: ['osd'],
        handler: (message, meta) => {
          const deviceId = meta?.fromUserId?.split('_')[0];
          const deviceInfo = getDeviceInfo(deviceId);
          const connection = getDeviceConnectionGroups(deviceId);
          const data = message.data;
          const method = message.method;

          if(
            data?.drc_state !== undefined && 
            getDeviceTelemetries(deviceId)?.drc_state !== data.drc_state
          ) {
            dispatch(setDeviceFlightAuthorityStatus({
              deviceId: deviceId,
              data: {
                authorityMode: data.drc_state ? DjiFlightJoystickAuthorityMode.DOCK : DjiFlightJoystickAuthorityMode.RC,
                authorityModeReason: data.drc_state ? DjiFlightJoystickAuthoritySwitchEvent.DOCK_DRC : DjiFlightJoystickAuthoritySwitchEvent.INTERNAL,
              }
            }));
          }
        }
      },
    ], 'device-flight-authority-observer');

    // check device info every 1 second
    permanentIntervalId.current = setInterval(() => {
      
    }, 1000);

    return () => {
      dockConnectionManager.unsubscribeGroupMessages(messageHandlerIds.current);
      clearInterval(permanentIntervalId.current);
    }
  }, []);

  return {};
}

export default useDeviceFlightAuthorityObserver;